import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=d98b96ce&scoped=true&"
import script from "./TaskType.vue?vue&type=script&lang=js&"
export * from "./TaskType.vue?vue&type=script&lang=js&"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=d98b96ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98b96ce",
  null
  
)

export default component.exports